var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSaveTaskTemplate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.029 12.43H2.17V2.586h11.657v4.923h.972V2.585a.991.991 0 0 0-.285-.697.965.965 0 0 0-.687-.288H2.171a.965.965 0 0 0-.687.288.991.991 0 0 0-.284.697v9.846c0 .261.102.511.284.696.183.185.43.288.687.288H7.03v-.984ZM3.53 4.75h4.86v.985H3.53v-.984Zm0 2.364h2.915v.984H3.53v-.984Zm8.355 2.363h.971v1.97H14.8v.984h-1.943v1.97h-.971v-1.97H9.943v-.985h1.943V9.477Z",
    fill: "#161616"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSaveTaskTemplate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/save-task-template.0a38889f0ce83907263180c1fda3daa2.svg";